import script from "./dataSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./dataSearch.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__